import { NodeService } from './node.service';
import { Injectable } from '@angular/core';

@Injectable()
export class HomePaginService {
  private items: any[] = [];
  private loadItems: any[] = [];
  private moreAssets: boolean;
  private numAssets: number = 10;

  constructor(private nodeService: NodeService) {}

  getAssetsIdsOwnedBy(address: string) {
    this.items = [];
    this.loadItems = [];
    this.moreAssets = false;
    return this.nodeService
      .getAssetsIdsOwnedBy(address)
      .then((assets: any[]) => {
        if (assets.length > 0) {
          this.moreAssets = true;
          this.items = assets;
        }
        return this.getBlockAssets();
      })
      .catch(asset => {
        return new Promise((resolve, reject) => {
          this.moreAssets = false;
          resolve(null);
        });
      });
  }

  getBlockAssets() {
    const num = this.setItemsToLoad();
    const max_num = num + this.numAssets;
    var itemsToLoad = [];

    if (this.items.length > this.loadItems.length) {
      for (let x = num; x < max_num; x++) {
        if (x < this.items.length) {
          this.loadItems.push(this.items[x]);
          itemsToLoad.push(this.items[x]);
        }
      }
      if (this.items.length == this.loadItems.length) this.moreAssets = false;

      return this.nodeService.getAssets(itemsToLoad);
    } else {
      return this.nodeService.getAssets([]);
    }
  }

  setItemsToLoad() {
    var num;
    var numItems = this.loadItems.length;
    if (!numItems) {
      return (num = 0);
    }
    if (numItems > 0) {
      return (num = numItems);
    }
  }

  getMoreAssets() {
    return this.moreAssets;
  }
}



// WEBPACK FOOTER //
// ./src/services/home.pagin.service.ts